import { Button, IconReload16, Responsive } from '@cian/ui-kit';
import * as React from 'react';

export interface IShowMoreButtonProps {
  onClick?(): void;
}

export const ShowMoreButton: React.FC<IShowMoreButtonProps> = ({ onClick }) => {
  return (
    <>
      <Responsive desktop>
        <Button
          size="XS"
          theme="stroke_primary"
          beforeIcon={<IconReload16 color="primary_100" />}
          data-name="ShowMoreButton"
          onClick={onClick}
        >
          Показать ещё
        </Button>
      </Responsive>
      <Responsive phone tablet>
        <Button
          fullWidth
          theme="fill_secondary"
          beforeIcon={<IconReload16 color="primary_100" />}
          data-name="ShowMoreButton"
          onClick={onClick}
        >
          Показать ещё
        </Button>
      </Responsive>
    </>
  );
};
